import { autoDarkColors } from "@/modules/theme/color/darkModeColor.ts";
import type { ThemeProps, ThemeVarGetters, ThemeVariant } from "@/modules/theme/types.ts";

import png from "@/styles/tenbyte/apple-touch-icon.png?url";
import icon from "@/styles/tenbyte/favicon.ico?url";
import favicon from "@/styles/tenbyte/favicon.svg?url";
import loginIntroBg from "@/styles/tenbyte/login-bg.jpg?url";
import logoDark from "@/styles/tenbyte/logo-dark.svg?url";
import loginLogo from "@/styles/tenbyte/logo.svg";
import logo from "@/styles/tenbyte/logo.svg?url";
import { Trans } from "@lingui/react/macro";

export function makeTheme(variant: ThemeVariant) {
    const { isDark } = variant;

    const baseColors: ThemeVarGetters = autoDarkColors({
        "color-primary": "#00cbb9",
        "color-secondary": "#e5e5e5",
    });

    return {
        ...baseColors,

        "logo-image": isDark ? `url("${logoDark}")` : `url("${logo}")`,

        "header-logo-width": "144px",
        "header-logo-height": "18px",

        "sidenav-item-text-color": isDark ? "#FFFFFF" : "var(--color-text)",
        "sidenav-item-before-display": "none",
        "sidenav-item-hover-bg-color": "var(--color-primary)",
        "sidenav-item-hover-icon-color": "#FFFFFF",
        "sidenav-item-hover-text-color": "#FFFFFF",
        "sidenav-item-active-bg-color": "var(--color-primary)",
        "sidenav-item-active-icon-color": "#FFFFFF",
        "sidenav-item-active-text-color": "#FFFFFF",
        "sidenav-item-active-before-display": "none",

        //#region Login
        "login-body-bg-color": "var(--color-white)",
        "login-body-bg-size": "cover",
        "login-body-text-color": "var(--color-white)",
        "login-justify-content": "space-between",
        "login-align-items": "stretch",

        "login-intro-display": "flex",
        "login-intro-bg-image": `url("${loginIntroBg}")`,
        "login-intro-bg-size": "cover",
        "login-intro-bg-position": "50% 50%",
        "login-intro-text-align": "left",
        "login-intro-flex-direction": "column",
        "login-intro-justify-content": "flex-end",
        "login-intro-align-items": "flex-start",
        "login-intro-padding": "60px",
        "login-title-font-size": "42px",
        "login-title-text-color": "",
        "login-title-font-weight": 600,
        "login-title-line-height": 1,
        "login-title-max-width": "400px",
        "login-title-padding": "0 0 16px 0",
        "login-subtitle-font-size": "16px",
        "login-subtitle-max-width": "400px",

        "login-form-title-font-size": "20px",
        "login-form-bg-color": "var(--color-white)",
        "login-form-text-color": "var(--color-text)",
        "login-form-input-border-color": "#dbe2e9",
        "login-form-button-border-radius": "var(--input-border-radius)",
        "login-form-or-text-color": "#dbe2e9",
        "login-form-or-border-color": "#dbe2e9",
        "login-form-google-bg-color": "#007bf5",
        "login-form-more-text-color": "#fd5b20",
        "login-form-more-bg-color": "var(--color-white)",
        "login-form-more-border-color": "#fd5b20",
        //#endregion
    } satisfies ThemeVarGetters;
}

export const props: ThemeProps = {
    favicon,
    icon,
    png,
    loginLogoImg: {
        src: loginLogo,
        style: {
            maxWidth: "240px",
        },
    },
    loginIntro: {
        style: {
            borderBottomLeftRadius: "50px",
            borderBottomRightRadius: "50px",
            margin: "0 0 20px 20px",
        },
    },
    baFieldPresentation: {
        document: {
            description: (
                <Trans comment="ONLY:bn">
                    <ul className="pl-0 m-0">
                        <li>Individual/Proprietor: NID, Passport, or Driver's License.</li>
                        <li>Company/Corporate: Trade License.</li>
                        <li>Financial & Legal: Tax Identification Number (TIN), VAT Certificate.</li>
                    </ul>
                </Trans>
            ),
        },
    },
};
